import React from 'react';

const Icon = ({ width = '13', height = '14', fill = 'white', ...other }) => {
    return (
        <svg width={width} height={height} viewBox="0 0 13 14" fill="none" {...other}>
            <path
                d="M3.615 4.972a.633.633 0 0 0-.9 0 .645.645 0 0 0 0 .907L6.11 9.3a.632.632 0 0 0 .894.006L10.4 5.968a.645.645 0 0 0 .01-.907.633.633 0 0 0-.9-.011L6.566 7.945l-2.95-2.973Z"
                fill={fill}
                fillOpacity="0.8"
            />
        </svg>
    );
};
export default React.memo(Icon);
